import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Grid,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TFunction } from 'i18next';
import { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-end',
      flexWrap: 'nowrap',
      gap: theme.spacing(1),
    },
  },
  titleContainer: {
    minWidth: 0,
  },
  title: { color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main },
  mobileTitle: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      overflowWrap: 'anywhere',
    },
  },
  desktopTitle: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  createButton: {
    textTransform: 'capitalize',
    color: theme.palette.primary.main,
    '&:hover': { backgroundColor: theme.palette.button.hover },
    [theme.breakpoints.down('md')]: {
      minWidth: theme.spacing(5.5),
      width: theme.spacing(5.5),
      height: theme.spacing(5.5),
      padding: 0,
    },
  },
  createButtonText: {
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  createIcon: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
  },
  tooltipButton: {
    width: theme.spacing(3.7),
    height: theme.spacing(3.7),
    color: theme.palette.grey[700],
  },
  contactAdminBadge: {
    backgroundColor: "#ff634724",
    color: "tomato",
    fontSize: "0.8rem",
    fontWeight: "bold",
    padding: "5px 10px",
    borderRadius: "4px"
  },
}));

type HeaderProps = {
  t: TFunction;
  userIsTitleEmployee: boolean;
  handleModalOpen: (state: boolean) => void;
  agencyName: string
};

const Header: FC<HeaderProps> = ({
  t,
  userIsTitleEmployee,
  handleModalOpen,
  agencyName
}) => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="space-between" alignItems="center" className={classes.headerContainer}>
      <Grid item className={classes.titleContainer}>
        <Typography variant="h4" className={`${classes.title} ${classes.desktopTitle}`}>
          {agencyName.length ? `${t('orders:orders-from')}${agencyName}` : t('orders:all-orders')}
        </Typography>
        <Typography variant="h4" className={`${classes.title} ${classes.mobileTitle}`}>
          {agencyName.length ? agencyName : t('orders:all-orders')}
        </Typography>
      </Grid>

      {userIsTitleEmployee && (
        <Grid item>
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            className={classes.createButton}
            onClick={() => handleModalOpen(true)}
            aria-label={t('orders:create-order')}
          >
            <Typography variant="body2" className={classes.createButtonText}>
              {t('orders:create-order')}
            </Typography>

            <FontAwesomeIcon
              icon="plus"
              size="sm"
              className={classes.createIcon}
            />
          </Button>
        </Grid>
      )}

      {!userIsTitleEmployee && (
        <Grid item>
          <Typography className={classes.contactAdminBadge}>
            {t('users:create-order-only-title-employee')}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default Header;
